import { ResultObj, allFetch } from "../Domain";


export type SystemSettingSearchParams = {
    ssm_name: string
}
export type SystemSettingSearchResItem = {
    note: string;
    ssm_id: number;
    ssm_name: string;
    value_json: string;
}

/**
 * @description 特殊系統設定查詢
 * @returns res
 */
export const SystemSettingSearch = async (obj: SystemSettingSearchParams = { ssm_name: '' }): Promise<ResultObj<SystemSettingSearchResItem[]>> =>
    await allFetch("SystemSettings/SystemSettingSearch", obj);


export type SystemSettingInsertParams = {
    ssm_name: string,
    value_json: string
}

/**
 * @description 特殊系統設定修改
 * @param {string}  ssm_id 流水號
 * @param {string}  value_json 內容
 * @returns res
 */
export const SystemSettingUpdate = async (obj: SystemSettingInsertParams): Promise<ResultObj<null>> =>
    await allFetch("SystemSettings/SystemSettingUpdate", obj);
